import * as React from "react";
import styles from "./style.module.scss";
import { Check, Copy } from "react-feather";
import { notification } from "antd";
import { useAppSelector } from "../../../store/hooks";
import { CopyButtonWithApproval } from "../../../pages/domain/create/copyButtonWithApproval";

interface Props {
  code: string;
  hideCopy?: boolean;
  className?: string;
  style?: React.CSSProperties;
}

export const CodeSnippet: React.FC<Props> = ({ code, hideCopy = false, className, style }) => {
  const theme = useAppSelector((state) => state.theme.theme);
  const [isCopied, setIsCopied] = React.useState(false);

  React.useEffect(() => {
    let intervalId: any;
    if (isCopied) {
      intervalId = setInterval(() => {
        setIsCopied(false);
      }, 1500);
    }
    return () => {
      clearInterval(intervalId);
    };
  }, [isCopied]);

  return (
    <div
      className={`relative p-4 flex justify-between rounded
      ${theme === "dark" ? styles["dark-wrapper"] : styles["wrapper"]} ${className}`}
      style={style}
    >
      <div className="mr-8 whitespace-pre-line">{code}</div>
      {hideCopy ? null : (
        <div className="absolute right-2">
          <CopyButtonWithApproval value={code} />
        </div>
      )}
    </div>
  );
};
